import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';

import SearchSelector from 'selectors/page/search/searchSelector';
import historyLocationSelector from 'selectors/historyLocation/historyLocationSelector';

import catalogActions from 'actions/CatalogActions';
import searchActions from 'actions/SearchActions';
import userActions from 'actions/UserActions';
import localeUtils from 'utils/LanguageLocale';

const { wrapHOC } = FrameworkUtils;
const { searchSelector } = SearchSelector;
const salePathRegExp = /^.*\/sale\?*$/i;
const searchPathRegExp = /^\/search*/;
const { isCanada } = localeUtils;

const shouldShowMidPageBanner = isSalePage => {
    if (isSalePage) {
        return false;
    }

    const isCAUnreleasedPlacementsVisible = Sephora.configurationSettings?.isCAUnreleasedPlacementsVisible;

    return isCanada() ? isCAUnreleasedPlacementsVisible : true;
};

const fields = createSelector(searchSelector, historyLocationSelector, (catalog, { path, queryParams, prevPath }) => {
    let isSearchPage = path && path.match(searchPathRegExp) != null;
    const isSalePage = path && path.match(salePathRegExp) != null;
    const showMidPageBanner = shouldShowMidPageBanner(isSalePage);

    if (!isSearchPage && !isSalePage && prevPath && prevPath.match(searchPathRegExp)) {
        isSearchPage = true;
    }

    return {
        catalog,
        isSalePage,
        isSearchPage,
        queryParams,
        showMidPageBanner
    };
});

const functions = {
    applyFilters: catalogActions.applyFilters,
    onStoreChangedFromHeader: userActions.onStoreChangedFromHeader,
    onZipCodeChangedFromHeader: userActions.onZipCodeChangedFromHeader,
    refreshSearchResults: searchActions.refreshSearchResults,
    dispatchMarketingParams: catalogActions.dispatchMarketingParams
};

const withSearchProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withSearchProps
};
